<template>
  <div class="vue-wrapper-sidebar">
    <div class="modal-window-header">
      <div class="modal-window-heading">
        <h3>Objektnotater</h3>
      </div>
      <a href="javascript:;" @click="closeSidebar()" class="modal-window-close-button modal-window-sidebar-close-button"><span>Lukk</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
    </div>

    <overlay-scrollbars v-if="!loading && (items.length > 0 || objekt.Merknad)" :options="{ className: 'modal-window-body gray os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <div class="messages-container" v-if="!loading && (items.length > 0 || objekt.Merknad)">

        <div class="message" v-if="objekt.Merknad">
          <div class="message-avatar">
            <span class="avatar name right" :class="strToAvatarClass('TK')">
              TK
              <span class="name">Tidligere kommentar</span>
            </span>
          </div>
          <div class="message-content">
            <p>{{objekt.Merknad}}</p>
          </div>
        </div>

        <div class="message" v-for="item in filteredItems" v-bind:key="item.id">
          <div class="message-avatar">
            <span class="avatar name right" :class="strToAvatarClass(item.bruker.initials || '-')" v-if="item.bruker">
              {{item.bruker.initials || '-'}}
              <span class="name">{{item.bruker.full_name || '-'}}</span>
            </span>
            <!-- Fallback to registret-av if no bruker found -->
            <span class="avatar name right" :class="strToAvatarClass('-')" v-else>
              {{item.Registrert_av || '-'}}
              <span class="name">{{item.Registrert_av || '-'}}</span>
            </span>
          </div>
          <div class="message-content">
            <p>
              {{item.Notat}}
              <span v-if="item.SentToAccounting"><br><br><em>Sendt til regnskap: {{item.SentToAccounting | avantidatenice}}</em></span>
            </p>
            <div v-if="item.images && item.images.length" class="message-image" style="display:flex; flex-wrap:wrap; gap:6px; margin-top:6px;">
              <img
                v-for="(img, idx) in item.images"
                :key="img.id"
                :src="apiBaseUrl + '/' + img.ImagePath"
                alt="Vedlegg"
                style="max-height:160px; border-radius:4px; cursor:pointer;"
                @click="openLightbox(item.images, idx)"
              />
            </div>

            <div class="message-timestamp"><time>{{item.Registrert_tid | avantidatenice}}</time></div>
            <template v-if="item.bruker && item.bruker.Brukerid === getUser.Brukerid">
              <a v-if="item.deleting" href="javascript:;" class="message-delete">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg>
                Sletter
              </a>
              <a v-else @click="deleteNotat(item)" href="javascript:;" class="message-delete">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg>
                Slett
              </a>
              <a v-if="item.sendingToAccounting" href="javascript:;" class="message-delete send-to-acct">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg>
                <span>Sender til regnskap...</span>
              </a>
              <a v-else href="javascript:;" @click="sendToAccounting(item)" class="message-delete send-to-acct">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg>
                <span>Send til regnskap</span>
              </a>
            </template>

            <template v-else>
              <a v-if="item.sendingToAccounting" href="javascript:;" class="message-delete">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg>
                <span>Sender til regnskap...</span>
              </a>
              <a v-else href="javascript:;" @click="sendToAccounting(item)" class="message-delete">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg>
                <span>Send til regnskap</span>
              </a>
            </template>
          </div>
        </div>
      </div>

      <div class="message" v-if="items.length > 0">
        <div style="width: 100%; text-align: center; margin-top: 10px" v-if="!everythingLoaded && pageCount > 1">
          <button href="javascript:;" @click="loadMore()" class="button secondary action glyph" v-if="!loading && !updating">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
            <span>Last fler</span>
          </button>
          <button href="javascript:;" class="button secondary action glyph loading" v-else>
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
            <span>Laster fler <span class="loader-spinner"></span></span>
          </button>
        </div>
        <div style="width: 100%; text-align: center; margin-top: 10px; font-size: 0.8em" v-else>
          Alt har blitt lastet inn
        </div>
      </div>
    </overlay-scrollbars>

    <div class="modal-window-body gray" v-else>
      <TheLoader :active="loading"/>
      <TheEmptyList v-if="!loading && (items.length < 1 && !objekt.Merknad)" :title="'Ingen objektnotater'" :message="'Objektnotater kan brukes som interne merknader som ikke er synlig for kunden.'" :large="false" :icon="'button-glyph-comment'"/>
    </div>

    <div class="grid-x toolbar footer">
      <form @submit.prevent="handleSubmit" style="width: 100%">
        <div class="cell">
          <div class="input-container" style="margin-bottom:0.5rem">
            <textarea
              autocomplete="off"
              placeholder="Legg til objektnotat…"
              v-model="newNotat"
              v-validate="'max:2000'"
              name="Notat"
              :disabled="$store.getters.isFormProcessing"
              :class="{ 'error': errors.has('Notat') }"></textarea>
          </div>
        </div>
        <div class="cell" v-if="newFilePreviews.length" style="margin-bottom:0.5rem; display:flex; flex-wrap:wrap; gap:0.5rem;">
          <div v-for="(preview, index) in newFilePreviews" :key="index" style="position:relative; display:inline-flex;">
            <img :src="preview" alt="Forhåndsvisning" style="max-height:100px; border-radius:4px;" />
            <a href="javascript:;" @click="removeFile(index)" class="button alert glyph-only" style="position:absolute; top:2px; right:2px; margin:0; padding:2px;" title="Fjern bilde">
              <svg width="12px" height="12px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg>
            </a>
          </div>
        </div>
        <div class="cell">
          <div class="grid-x">
            <TheSwitchInput v-model="SendToAccounting" containerClassName="cell auto" switchContainerStyle="margin: 0" :small="true" :align="'left'" labelTrue="Send til regnskap" labelFalse="Send til regnskap" :trueValue="true" :falseValue="false"/>
            <div class="cell shrink" style="display:flex; gap:0.5rem;">
              <label class="button secondary" style="margin:0; cursor:pointer; white-space:nowrap; width:auto; padding-left:0.75rem; padding-right:0.75rem;">
                Last opp foto
                <input type="file" accept="image/jpeg,image/png,image/gif,image/webp" multiple style="display:none" @change="onFileChange" :disabled="$store.getters.isFormProcessing" ref="fileInput" />
              </label>
              <a href="javascript:;" v-if="$store.getters.isFormProcessing" class="button primary loading"><span class="button-title">Lagrer notat</span> <span class="loader-spinner"></span></a>
              <a href="javascript:;" v-else-if="!isFormSubmittable()" class="button primary disabled"><span class="button-title">Lagre notat</span></a>
              <a href="javascript:;" v-else @click="handleSubmit()" class="button primary"><span class="button-title">Lagre notat</span></a>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="expandable-search" style="margin-bottom: 3.4rem;" :class="{'active': searchBoxActive, 'search-active': search != ''}" v-if="!loading && items.length > 0">
      <div class="input-container search no-margin comment">
        <input  class="rounded" type="text" placeholder="Søk i objektnotater…" v-model="search" v-on:keydown="onSearchInput" v-on:blur="toggleSearchbox(false)" v-on:focus="toggleSearchbox(true)">
        <button class="glyph-button" type="submit">Søk <svg width="14px" height="14px" viewBox="0 0 14 14"><use xlink:href="/static/sprites.svg#glyph-input-search"></use></svg></button>
        <a href="javascript:;" @click="clearSearch()" class="cancel-search"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
      </div>
    </div>

    <div class="sidebar-overlay" @click="closeSidebar()"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektSidebarNotater',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      newNotat: '',
      newFiles: [],
      newFilePreviews: [],
      SendToAccounting: false,
      search: '',
      searchBoxActive: false,
      apiBaseUrl: process.env.VUE_APP_AVANTI_API_URL || ''
    }
  },
  created () {
    this.setFormLoading(false)

    // Not in use, as we removed paging
    this.currentPage = this.queryParams.page || 1

    // Debounced input
    this.onSearchInput = this._.debounce(this.onSearchInput, 500)
  },
  computed: {
    ...mapGetters(['getUser']),
    ...mapGetters('objektnotat', [
      'items',
      'pageCount',
      'totalCount',
      'everythingLoaded',
      'queryParams',
      'loading',
      'updating'
    ]),
    filteredItems: function () {
      if (!this.search) {
        return this.items
      }

      return this.items.filter((i) => {
        return this._.includes(this._.toLower(i.Notat), this.search)
      })
    }
  },
  methods: {
    openLightbox: function (images, startIndex) {
      this.openModal('NotatImageLightboxModal', { images, startIndex, apiBaseUrl: this.apiBaseUrl }, 'large')
    },
    clearSearch: function () {
      this.search = ''
      this.toggleSearchbox(false)
    },
    toggleSearchbox: function (mode) {
      if (mode === false) {
        this.searchBoxActive = this.search !== ''
      } else {
        this.searchBoxActive = true
      }
    },
    onSearchInput: function (e) {
      // In it's own method, so we can have debounce
      this.search = this._.toLower(e.target.value.trim())
    },
    closeSidebar: function () {
      bus.$emit('close-objekt-sidebar')
    },
    loadMore: function () {
      let page = this.currentPage + 1

      if (page > this.pageCount) {
        console.log('Last page already loaded')
        return
      }

      // Make query to load more...
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = page
      copiedParams.page = this.currentPage

      this.$store.dispatch('objektnotat/reload', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr,
        Objektid: this.objekt.Objektid,
        queryParams: copiedParams
      }).then((response) => {
      })
    },
    onFileChange: function (e) {
      const files = Array.from(e.target.files)
      if (!files.length) return
      this.newFiles = [...this.newFiles, ...files]
      this.newFilePreviews = [...this.newFilePreviews, ...files.map(f => URL.createObjectURL(f))]
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },
    removeFile: function (index) {
      this.newFiles.splice(index, 1)
      this.newFilePreviews.splice(index, 1)
    },
    clearFiles: function () {
      this.newFiles = []
      this.newFilePreviews = []
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre objektnotat', 'Vennligst korriger feil i skjemaet')
          } else if (!this.newNotat && !this.newFiles.length) {
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Notat mangler innhold', 'Legg til tekst eller et bilde')
          } else {
            let payload = {
              Objektid: this.objekt.Objektid,
              Notat: this.newNotat
            }

            if (this.SendToAccounting) {
              payload.SendToAccounting = true
            }

            if (this.newFiles.length) {
              payload.ImageFiles = this.newFiles
            }

            const prevNotat = this.newNotat
            const prevFiles = this.newFiles.slice()

            this.$store.dispatch('objektnotat/save', payload)
              .then(() => {
                this.SendToAccounting = false
                this.newNotat = ''
                this.clearFiles()
                this.setFormProcessing(false)
              })
              .catch(() => {
                this.newNotat = prevNotat
                this.newFiles = prevFiles
                this.$helpers.showErrorAlert('Kunne ikke lagre objektnotat', 'Vennligst prøv igjen')
                this.setFormProcessing(false)
              })
          }
        })
    },
    sendToAccounting: function (item, index) {
      console.log('Send to accounting')
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      let payload = {
        Objektid: this.objekt.Objektid,
        id: item.id
      }

      this.$store.dispatch('objektnotat/sendToAccounting', payload)
        .then(() => {
          this.$helpers.showSuccessAlert('Objektnotat har blitt sendt til regnskap')
          this.setFormProcessing(false)
        })
        .catch(() => {
          this.$helpers.showErrorAlert(
            'Kunne ikke sende objektnotat til regnskap',
            'Vennligst prøv igjen eller send en e-post til<br><a href="mailto:regnskap@blomqvist.no">regnskap@blomqvist.no</a>',
            true,
            3500
          )
          this.setFormProcessing(false)
        })
    },
    deleteNotat: function (item) {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      let payload = {
        Objektid: this.objekt.Objektid,
        id: item.id
      }

      this.$store.dispatch('objektnotat/delete', payload)
        .then(() => {
          this.$helpers.showSuccessAlert('Objektnotat er slettet')
          this.setFormProcessing(false)
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Kunne ikke slette objektnotat', 'Vennligst prøv igjen')
          this.setFormProcessing(false)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektSidebarNotater.vue